module.exports = __webpack_public_path__ + "img/1_Artsetlitterature.225e8321.png";